import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Button } from "../../_components";
import I18 from "../../_components/atoms/i18";
import ModalForm from "../../_components/model2";
import { ListView } from "../../_components/molecule/listview.component";
import Label from "../../_components/typography/label.typography";
import { CourseService } from "../../_service";
import CreateCourse from "./create-course";
import { useAppService } from "../../hooks/use-app-service";

export const COURSE_PAGE_ROUTE = "/course";
function CoursePageComponent({ community, user }) {
  const { analyticsService } = useAppService();

  const [isVisible, setIsVisible] = React.useState(false);
  const [courses, setCourses] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const communityId = community?.id;

  // Determine if the user has permission to create/edit a course
  const hasWritePermission = user && ["admin"].includes(community?.myRole);

  //  Get courses
  useEffect(() => {
    if (!communityId) return;

    setIsLoading(true);

    CourseService.getAllCourses(communityId)
      .then(({ courses }) => {
        setCourses(courses);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [communityId]);

  if (community?.configuration?.isExploreCourseDisabled) {
    return <Redirect to="/" />;
  }

  return (
    <div className="CoursePage flex flex-col space-y-2 px-2 sm:px-0">
      {/* HEADER */}
      <div className="flex flex-col theme-bg-surface pl-4 pr-2 py-4 shadow rounded">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4 font-bold theme-text-heading-2">
            <I18> Explore Course</I18>
          </div>
          {hasWritePermission ? (
            <>
              <ModalForm
                title={"Add new course"}
                className="w-full sm:w-2/3 md:w-2/4 lg:w-1/3"
                visible={isVisible}
                setVisible={setIsVisible}
                button={
                  <Button
                    label="Add Course"
                    onClick={() => {
                      analyticsService.track("add-course-button-clicked");
                      setIsVisible(true)
                      }
                    }
                  />
                }
                >
                <CreateCourse
                  community={community}
                  setVisible={setIsVisible}
                  onCourseCreated={(course) => {
                    setIsVisible(false);
                    setCourses([...courses, course]);
                  }}
                />
              </ModalForm>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* BODY */}

      <ListView
        items={courses}
        loading={isLoading}
        placeholder={
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 py-4">
            {[1, 2, 3, 4, 6, 7, 8, 9, 10].map((i) => (
              <div key={i} className="animate-pulse">
                <div className="theme-bg-disable h-48 rounded"></div>
              </div>
            ))}
          </div>
        }
        renderItem={(course) => <CourseCard course={course} />}
        noItemsElement={
          <div className="flex flex-col items-center w-full my-auto text-center h-52">
            <div className="flex flex-grow items-center">
              <Label translate size="h3" variant="t2">
                No Course available
              </Label>
            </div>
          </div>
        }
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 py-4"
      />
    </div>
  );
}
function CourseCard({ course }) {

  const { analyticsService } = useAppService();
  
  const triggerAnalyticsEvent = () => {
    analyticsService.track("course-selected-in-courses-window", {
      courseId: course.id,
      courseTitle: course.title
    })
  }

  return (
    <Link onClick={triggerAnalyticsEvent} to={`course/${course.id}`} href={`course/${course.id}`}>
      <div className="theme-bg-surface border theme-border-default rounded ">
        <div
          className="theme-bg-primary  object-cover"
          style={{
            ...{
              backgroundColor: "var(--theme-primary-light-color)",
              aspectRatio: "16/6",
            },
          }}>
          {course?.banner && (
            <img src={course?.banner} className="rounded-t" alt="banner" />
          )}
        </div>
        <div className="flex flex-col space-y-2 p-2">
          <h3 className="font-semibold theme-text-heading-1">{course.title}</h3>
        </div>
      </div>
    </Link>
  );
}

const CoursePage = connect((s) => ({ user: s.auth, community: s.community }))(
  CoursePageComponent
);

// const CoursePage = CoursePageComponent;
export default CoursePage;
